import { h, Component } from "preact";
import { connect } from "react-redux";
import { timeExpired } from "../state/actions/orderActions";
import { Link } from "preact-router/match";
import config from "../config";
import Modal from "./Modal";
import Button from "./Button";
import { css } from "emotion";

const modalContent = css({
  textAlign: "center",
  paddingTop: 28,
  maxWidth: 400,
  width: "calc(100vw - 78px)",
  margin: "0 auto",
  h3: {
    marginBottom: 6
  },
  p: {
    marginBottom: 40
  },
  button: {
    height: 40
  }
});

class CountDown extends Component {
  constructor() {
    super();
    this.state = {
      timeLeft: "19:59"
    };
  }

  componentWillMount() {
    const ORDER_COMPLETE_TIME = this.getOrderTime();
    const startMin = ORDER_COMPLETE_TIME - 1;
    this.setState({
      timeLeft: `${startMin}:59`
    });
  }

  componentDidMount() {
    const { order } = this.props;
    if (!order || !order.data || !order.data.createdAt) {
      return;
    }
    this.updateInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
    this.updateCountdown();
  }

  componentWillUnmount() {
    if (!this.updateInterval) {
      return;
    }
    clearInterval(this.updateInterval);
  }
  pad2(number) {
    return (number < 10 ? "0" : "") + number;
  }

  getOrderTime = () => {
    const { event, isGlobal } = this.props;
    const ORDER_COMPLETE_TIME =
      !isGlobal && event.data.settings.customTimeout
        ? event.data.settings.customTimeout
        : config("ORDER_COMPLETE_TIME");
    return ORDER_COMPLETE_TIME;
  };

  updateCountdown() {
    const { order, timeExpired } = this.props;
    const ORDER_COMPLETE_TIME = this.getOrderTime();
    const startMin = ORDER_COMPLETE_TIME - 1;
    if (!order || !order.data) {
      return;
    }
    const createdDate = new Date(order.data.createdAt);
    const now = new Date();
    let diff = (now - createdDate) / 1000;
    const minutes = Math.floor(diff / 60) % 60;
    const diffLeft = diff - minutes * 60;
    const seconds = Math.floor(diffLeft % 60);
    const display = `${startMin - minutes}:${this.pad2(59 - seconds)}`;
    if (diff > ORDER_COMPLETE_TIME * 60) {
      timeExpired();
      clearInterval(this.updateInterval);
      this.setState({ timeLeft: "0:00" });
      return;
    }
    this.setState({ timeLeft: display });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.order.timeExpired && this.props.order.timeExpired) {
      try {
        document.getElementById("reorderButton").focus();
      } catch (err) {}
    }
  }

  getRestartUrl() {
    const { isGlobal, event, giftCards } = this.props;
    if (isGlobal) {
      const { giftCardPage } = giftCards;
      return `/gift-cards/${giftCardPage.slug}`;
    } else {
      return `/${event.data.slug}/tickets`;
    }
  }

  render({ order, margin }) {
    const { timeLeft } = this.state;
    const color = "#f6eecd";
    const background = "#fff9e1";
    const style = {
      transition: "all 0.5s ease",
      background: `${background}`,
      margin: margin ? margin : "0 0 12px 0",
      border: `1px solid ${color}`,
      borderRadius: 4,
      display: "block",
      textAlign: "center",
      padding: 8
    };
    const messageStyle = {
      margin: 0,
      fontSize: 14
    };
    if (!order || !order.data || !order.data.createdAt) {
      return "";
    }

    return (
      <div style={style}>
        <Modal
          showModal={order.timeExpired}
          closeHandler={() => (window.location.href = this.getRestartUrl())}
        >
          <div className={modalContent}>
            <h3>Your checkout time has expired</h3>
            <p>The tickets have now been released.</p>
            <Button
              onClick={() => (window.location.href = this.getRestartUrl())}
              type="primary"
            >
              Reorder
            </Button>
          </div>
        </Modal>
        <p style={messageStyle}>Checkout time left: {timeLeft}</p>
      </div>
    );
  }
}

export default connect(
  state => ({
    order: state.order,
    event: state.event,
    giftCards: state.giftCards
  }),
  { timeExpired }
)(CountDown);



// WEBPACK FOOTER //
// ./components/CountDown.js